import { BOUNDARY_OPTIONS } from "../LocalConst";

export class Concept {
    conceptType = null;
    conceptDataType = null;
    parent = null;
    conceptAnswers = null;
    conceptNumerics = null;
    conceptAttributes = null;
    name = null;
    code = null;
    description = null;
    parentCode = null;
    icdCode10 = null;
    usageStatus = true;
}

export class ConceptNumerics {
    id = null;
    concept = null;

    hiAbsolute = null; //
    lowAbsolute = null;

    hiCritical = null;
    lowCritical = null;

    hiNormal = null;
    lowNormal = null;

    units = null;
    displayPrecision = null;
    boundaryOptions = BOUNDARY_OPTIONS[2].value
}

export class ConceptAnswer {
    id = null;
    concept = null;
    answerConcept = null;
    viewIndex = null;// thứ tự hiển thị (thứ tự cao là kết quả cao)
}

export class Drug {
    isContraindicated = false;
    drug = null;
}